// @flow
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ItemCartContainer from '../../containers/ItemCartContainer';
import {Desktop, UntilTablet} from '../../../../utils/responsive';
import {postForecastClassicPriceApi} from '../../../new-order/QuoteStep/api';
import {Link} from 'react-router-dom';
import moment from 'moment';
import {CommaFormat} from '../../../../elements/Price/Price';

import iconImage from '../../../../assets/img/shopping-cart/qempo-full-active.png';
import qempoFullActiveImage from '../../../../assets/img/shopping-cart/qempo-full-active.png';

import style from './QempoFullContent.scss';

import type {ShoppingCartItem} from '../../../../entities';
import type {ForecastTier, ForecastType, Forecast} from '../../../new-order/QuoteStep/api';
import SummaryModal from "../../../new-order/ProductStep/components/NewProductForm/QuoteBox/SummaryModal/SummaryModal";

type Props = {
  subtype: string;
  items?: ShoppingCartItem[];
  isFetchingShoppingCart?: boolean;
  isDeletingItem?: boolean;
  isEditingItem?: boolean;
  fetchCheckoutDataSuccess: (forecast: Forecast, selectedIndex: number,
                             importMethod: ForecastType, shoppingCartItems?: ShoppingCartItem[]) => void;
};

type State = {
  forecastClassic?: ForecastTier;
  forecastClassics?: ForecastTier[];
  isLoadingForecast: boolean;
  summaryOpen: boolean;
};

const CONST_FLEXIBLE = 'FLEXIBLE';

export default class QempoFullContent extends Component<Props, State> {
  state: State = {
    summaryOpen: false,
    isLoadingForecast: false,
  };

  componentDidMount() {
    const {items, subtype} = this.props;

    if (items) {
      this.forecastData(items, subtype);
    }
  }

  componentDidUpdate(prevProps: Props) {
    const {items, subtype} = this.props;

    if (
      (prevProps.items && items) &&
      (
        (prevProps.items.length !== items.length) ||
        (
          prevProps.items.length === items.length &&
          items.some((i, idx) => i.amount !== (prevProps.items: any)[idx].amount)
        )
      )
    ) {
      this.forecastData(items, subtype);
    }
  }

  forecastData(items: ShoppingCartItem[], subtype: string) {
    const itemsReq: { [key: string]: any }[] = items.map((item) => {
      const itemReq: { [key: string]: any } = {
        url: item.url,
        name: item.name,
        categoryId: parseInt(item.itemCategoryId, 10),
        price: item.price,
        amount: item.amount,
        originalPackaging: item.originalPackaging,
        shipping: item.shipping,
      };

      if (item.volumeTier) itemReq.volumeTier = item.volumeTier.code;
      if (item.weight) itemReq.weight = item.weight;

      return itemReq;
    });

    const req = {
      deliveryCountry: 'PE',
      purchaseCountry: 'US',
      items: itemsReq,
    };

    this.setState({isLoadingForecast: true}, () => {
      postForecastClassicPriceApi(req).toPromise().then((forecast: ForecastTier[]) => {
        const forecastClassic = forecast.find((f) => f.tier.name === subtype);
        this.setState({isLoadingForecast: false, forecastClassic, forecastClassics: forecast});
      });
    });
  }

  handleClick = () => {
    const {items, fetchCheckoutDataSuccess} = this.props;
    const {forecastClassic} = this.state;

    const forecastCLASSIC: Forecast = {
      DIY: [],
      CLASSIC: forecastClassic ? [forecastClassic] : []
    };

    fetchCheckoutDataSuccess(forecastCLASSIC, 0, 'CLASSIC', items);
  };

  render() {
    const {subtype, items, isFetchingShoppingCart, isDeletingItem, isEditingItem} = this.props;
    const {forecastClassic, isLoadingForecast, summaryOpen} = this.state;

    const start = moment().local();
    const end = moment().local().add(1, 'days').startOf('day');
    const duration = moment.duration(end.diff(start));

    const diff = `${duration.hours()}hrs ${duration.minutes()}min`;

    return (
      <Fragment>
        <div
          className={`${style.qempoFullContentRoot} ${(isFetchingShoppingCart || isDeletingItem || isLoadingForecast || isEditingItem) ? style.isLoading : ''}`}>
          <button className={style.headerWrap}>
            <div className={style.headerContent}>
              <img
                src={qempoFullActiveImage}
                alt="Qempo Full"
              />
              <div>
                <p className={style.title}>
                  Qempo Full
                  <span> - {`${subtype === CONST_FLEXIBLE ? 'Viajero' : 'Carga comercial'}`}</span>
                </p>

                <span className={style.header}>
                  Realiza el pago y nosotros nos encargaremos
                  de todo.
                </span>
              </div>
            </div>
            <div className={style.deliveryDate}>
              {forecastClassic &&
                <h6>{`Recíbelo antes del ${moment().add(forecastClassic.tier.days, 'days').format('D MMMM, YYYY')}`}</h6>}
              <span>si lo compras en {diff}</span>
            </div>
          </button>

          {items && items.map((item: ShoppingCartItem, index: number) => (
            <ItemCartContainer
              key={`item-cart-${index}`}
              item={item}
              type="FULL"
            />
          ))}
          <div className={style.subtotalWrap}>
            <div className={style.subtotalContent}>
              <button onClick={() => this.setState({summaryOpen: true})}
                      className={style.seeSummary}>Ver detalle
              </button>
              <Link className={style.buttonPayment} to="/new-order/checkout/items" onClick={this.handleClick}>
                <div className={style.leftWrap}>
                  <h6>Ir a pagar</h6>
                </div>
                <div className={style.priceWrap}>$ {forecastClassic ?
                  <CommaFormat price={forecastClassic.total}/> : '??.??'}</div>
              </Link>
              <span>Incluye todos los gastos hasta tus manos.</span>
            </div>
          </div>
        </div>
        {forecastClassic && (
          <SummaryModal isOpen={summaryOpen}
                        handleClose={() => this.setState({summaryOpen: false})}
                        forecastClassic={[forecastClassic]}
                        methodType="FULL"
                        fullSubtype={subtype}
          />
        )}
      </Fragment>
    );
  }
}

QempoFullContent.propTypes = {
  subtype: PropTypes.string.isRequired,
  items: PropTypes.array,
  isFetchingShoppingCart: PropTypes.bool,
  isDeletingItem: PropTypes.bool,
  isEditingItem: PropTypes.bool,
  fetchCheckoutDataSuccess: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/shopping-cart/components/QempoFullContent/QempoFullContent.jsx